import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSettingsAction } from '../../actions/settings.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateSocialWhatsap } from '../../slices/settings.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const SocialWhatsappPage = () => {
  const dispatch = useAppDispatch();

  const { social_whatsapp } = useAppSelector((store) => store.settings.list);

  const handleChange = (v: string) => {
    dispatch(updateSocialWhatsap(v));
  };

  const handleSave = async () => {
    await dispatch(updateSettingsAction({ key: 'social_whatsapp', value: social_whatsapp }));
  };

  return (
    <ContainerTemplate>
      <Card title="Whatsapp" className={'border-2 border-yellow'}>
        <div>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={social_whatsapp ?? ''}
            onChange={({ target }) => handleChange(target.value)}
          />
        </div>
        <Button label="Сохранить" icon="pi pi-check" className={'mt-2'} onClick={handleSave} />
      </Card>
    </ContainerTemplate>
  );
};
